import React from "react";

function BtnRounded({ children, onClick, className, bgColor = "bg-customAqua600" }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 lg:px-6 lg:py-3 ${bgColor} text-white rounded-full hover:bg-customAqua100 transition duration-300 ${className}`}
    >
      {children}
    </button>
  );
}

export default BtnRounded;
